<script setup>
import XuTitle from './XuTitle.vue'
import Silde from "./Slide.vue"
// import DashboardChart from './DashboardChart.vue'
import RollSlide from "./RollSlide.vue"
import TableSlide from './TableSlide.vue'
// import Resource from './Resource.vue'
// import ChartMap from './ChartMap.vue'
// import PieChart from './PieChart.vue'
import BarChart from './BarChart.vue'
import TempMode from "./TempMode.vue"
// import ChartScatter from './ChartScatter.vue'
// import BtnGroup from "./BtnGroup.vue"
import eventHub from "@/utils/eventHub";
import { ref, onMounted } from 'vue';
import DoughnutChart from './DoughnutChart.vue'
import ColdRoomRunTime from './ColdRoomRunTime.vue'
// import { getBriefIntroduction } from "@/api/common";
// var player;
let showBigScreen = ref(true);
// let sildeText = ref(null)
eventHub.on("hideBigScreen", () => {
  showBigScreen.value = false;
});
eventHub.on("showBigScreen", () => {
  showBigScreen.value = true;
});
</script>

<template>
  <div id="bigScreen">
    <!-- <div> -->
      <div class="header">
      <img class="logo" src="../assets/logo.png" alt="logo">
      智枫（天津）供应链智慧大屏</div>
      <!-- <BigTitle smallTitle="GERMPLASMS MONITOR SCREEN" title="国家林木种质资源设施保存库湖南分库" subTitle=""></BigTitle> -->
      <!-- <div class="center-box">
        <SearchBox></SearchBox>
      </div> -->
      <!-- <BtnGroup></BtnGroup> -->
    <!-- </div> -->
    <div v-show="showBigScreen" class="main-box">
      <div class="left">
        <XuTitle title="项目简介" subTitle="BRIEF INTRODUCE"></XuTitle>
        <Silde class="">
          <pre class="content">
    公司坐落于天津市武清区金博工业园金立路2号，地缘位置优越，处于京津冀都市圈中心位置，距北京、天津核心城区约50公里，车程1小时以内，公司位于北京和天津的中间地带，有多条高速公路、国道和省道经过，东临京津塘高速公路，南近滨保高速公路，西靠京沪高速公路，北接京津高速公路，高速公路形成环状，交通十分便利。公司到机场、港口还有车站也十分便利，到北京大兴国际机场直线距离50km，到北京首都国际机场直线距离80km，到天津西站直线距离36km，到天津滨海国际机场直线距离50km，到天津港/中心渔港80km。智枫供应链优越地理位置让您通过临近高速快速到达国内任何一座城市，让您拥有“快人一步”优势。
    智枫供应链一号库建筑总面积12500平方米，仓储能力共计约15000吨，采用智能化制冷系统调控多温度环境仓储解决方案，兼具冷冻、冷藏、恒温三种功能。穿堂净高7.5米，长162米，宽13米，穿堂温度控制在10°(±3°)，有13个货物装卸道口，正常情况下每天装卸能力满足1000吨，每月能够满足15000吨装卸能力。
    冷冻库总面积7000平方米，共分5个库区，净高为10.3米，冷冻容量12000吨，仓储温度满足-18℃至 -22℃。1号库区为巧固架地堆库，有2000个巧固架。2、3、4、5号库区均为双深位货架库，有9500个托盘位。
    6号库为冷藏库，建筑面积为1100平方米，净高为10.3米，冷藏容量1500吨，仓储温度0℃至 7℃；7号库为恒温库，做预留加工区用，建筑面积为1150平方米，净高为10.3米，恒温容量1500吨，仓储温度7℃至 12℃。
    我们现在严格按照IOS体系规范操作，利用智慧化WMS管理平台标准化作业以满足货物与货区的智能区块化管理，形成数字化指令闭环，最大程度避免人为干预错误。此外还采用天商智能系统集成的应用在互联网、物联网、大数据的加持下形成高速互通的业务效率。库区建立了360°全方位无死角监控系统可以随时请客户观看。采购冷库专业叉车和物料搬运设备分别有3台林德平衡重叉车，5台科朗双深位叉车；冷库采用双电源供电系统，另外铺设光伏能源板，最大程度使用绿色能源，做到双碳减排，碳达峰，建设成为一座现代化绿色工厂。
    智枫供应链集冷冻、冷藏、食品预加工多功能模块一体化，致力于为冷链物流、食品加工销售行业提供管家式一站式服务。我们拥有一支成熟运营管理、超前业务思维的优秀团队，已与多家央企国企保持紧密合作。为满足客户不同需求，我们将仓储加工服务具象话，把业务流程规范化，我们根据客户需求，制定最高效、最经济的仓储解决方案。我们涵盖业务种类多样，如现代物流项目策划、冷链技术支持服务、供应链金融、城市配送、食品预加工、进出口贸易业、一件代发等多种类服务。
          </pre>
          <!-- 天津市农作物种质资源库立项2019年8月，于2021年12月1日正式动工。
            <br>
            项目占地2020平方米，地上两层钢框架结构。
            <br>
            总建筑面积1972 ㎡，其中包含种质保存库1270 ㎡，农作物种质资源精准鉴评公共平台296
            ㎡，种质信息共享平台建设规模为57 ㎡，配套用房建设规模349㎡。项目建成后种质资源贮存能力可达40万份库区建设规模793 ㎡，库区使用面积550 ㎡（缓冲占42㎡），包括中期库129㎡、中期可调库236 ㎡、长期库76
            ㎡、自动存取库42 ㎡。<br><br><br><br> -->
        </Silde>
        <!-- <XuTitle title="种质资源库占比" subTitle="GERMPLASM INVENTORY"></XuTitle> -->
        <XuTitle title="能耗组成占比" subTitle="ENERGY COMPOSITION"></XuTitle>
        <div class="flex-box flex-space-between mt-20 inventory-box">
          <!-- <DashboardChart></DashboardChart> -->
          <DoughnutChart />
          <RollSlide></RollSlide>
        </div>
        <TableSlide></TableSlide>
        <BarChart></BarChart>
        <!-- <Resource></Resource> -->
      </div>
      <div class="center">
        <!-- <ThreeMode></ThreeMode> -->
        <!-- <PieChart></PieChart> -->
        <TempMode></TempMode>
      </div>
      <div class="right">
        <XuTitle title="视频介绍" subTitle="VIDEO INTRODUCE"></XuTitle>
        <div class="video-box">
          <video src="/assets/video.mp4" muted controls autoplay loop></video>
        </div>
        <!-- <XuTitle title="业务范围" subTitle="GEOGRAPHIC COVERAGE"></XuTitle>
        <ChartMap></ChartMap> -->
        <!-- <BarChart></BarChart> -->
        <!-- <ChartScatter></ChartScatter> -->
        <ColdRoomRunTime></ColdRoomRunTime>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#bigScreen {
  // width: 1920px;
  // height: 1080px;
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 110;
  padding: 0 20px 20px;
  left: 0;
  top: 0;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main-box {
  display: flex;
  justify-content: space-between;
  height: calc(100% - 50px);
  margin-top: -20px;
}

.left {
  width: 430px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right {
  width: 370px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.center {
  position: relative;
  display: flex;
  flex-direction: column;
  width: calc(100% - 800px);
  margin: 0 20px;
}

.video-box {
  width: 100%;
  // height: 20vh;
  margin-top: 10px;
  padding: 14px 14px 10px;
  background: url("../assets/video-bg.png") no-repeat;
  background-size: 100% 100%;
  box-sizing: border-box;
  pointer-events: all;

  video {
    width: 100%;
    height: 216px;
  }
}


.content {
  position: absolute;
  width: 100%;
  white-space: pre-wrap;
  font-weight: 500;
  font-size: 14px;
}

.inventory-box {
  height: 200px;
}
.header {
  height: 70px;
  background-image: url(@/assets/title.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  color: rgb(240, 245, 251);
  font-size: 35px;
  font-weight: bold;
  line-height: 70px;
  // text-shadow: 0 0 10px #fff;
  letter-spacing: 5px;
  // filter: hue-rotate(5deg) brightness(4.8);
}
.logo{
  width: 50px;
  height: 50px;
  vertical-align: middle;
}
</style>
